import './stylesheets'
import 'react-hot-loader'
import React from 'react'
import ReactDOM from 'react-dom'  // n.b. that previous version was "^4.3.1"
import { connectRouter } from 'connected-react-router'

import App from './app'
import rootReducer from './reducers'
import history from './history'
import store from './store'
import AmplifyBridge from './store-amplify-bridge'

import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import awsconfig from './awsconfig';

// @FIXME consider tracking user activities
// import Analytics from '@aws-amplify/analytics';
// See: https://github.com/aws-amplify/amplify-js/blob/master/README.md#1-collect-user-session-metrics

Amplify.configure(awsconfig);

new AmplifyBridge(store);

const render = () => {
    const AppNext = require('./app').default;
    ReactDOM.render(
        <AppNext history={history} store={store}/>,
        document.getElementById('react-root')
    )
}

let app_is_loaded = false;
document.addEventListener("DOMContentLoaded", () => {
    if(!app_is_loaded && document.getElementById('react-root')){
        render();
        app_is_loaded = true;
        console.log('mounted app');
    }else{
        console.debug('Element #react-root not found.')
    }
})

// Hot reloading
if (module.hot) {
    // Reload components
    module.hot.accept('./app', () => {
        render();
    })

    // Reload reducers
    module.hot.accept('./reducers', () => {
        store.replaceReducer(connectRouter(history)(rootReducer))
    })
}